<template>
  <v-card v-if="!loading" flat style="width: 100%">
    <template v-if="orders.length !== 0">
      <div style="text-align: right" class="mr-2">
        <v-btn outline small color="primary" style="min-width: 50px" @click="refreshData">
          <em class="fa fa-refresh" style="font-size: 17px" aria-hidden="true"
        /></v-btn>
      </div>

      <v-layout row wrap>
        <v-flex v-for="(order, index) in orders" :key="index">
          <LivechatOrderSummaryItem
            :order="order"
            :loading="loadUpdateOrder"
            @updateOrder="updateOrder"
          />
        </v-flex>
      </v-layout>
      <infinite-loading v-if="orders.length" spinner="spiral" @infinite="infiniteScroll">
        <span slot="no-more"></span
      ></infinite-loading>
    </template>
    <div v-else class="text-xs-center pa-3">
      <span>{{ $t('Not have any order now') }}</span>
    </div>
  </v-card>
  <div v-else class="spinner text-xs-center pt-3">
    <v-progress-circular :indeterminate="true" :height="2" color="primary"></v-progress-circular>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import InfiniteLoading from 'vue-infinite-loading'
import api from '@/api'
import EditAddress from '../template/ecommerce/EditAddress.vue'
import LivechatOrderSummaryItem from './LivechatOrderSummaryItem.vue'
import { mapGetters } from 'vuex'

export default {
  components: { InfiniteLoading, EditAddress, LivechatOrderSummaryItem },
  data() {
    return {
      loadUpdateOrder: false,
      orders: [],
      offset: 0,
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      currentLang: 'currentLang',
      selectedBot: 'selectedBot'
    })
  },
  created() {
    this.fetchData()
  },
  mounted() {},
  methods: {
    onSelectOrderStatus: function (status) {
      var order = this.order
      order.status = status.value
      this.$emit('input', order)
    },
    updateOrder(payload) {
      const { order, isSend } = payload
      // console.log(order)

      let vm = this
      vm.loadUpdateOrder = true
      if (isSend == 'send' && order.status == 'canceled') order.sendreason = true
      else if (isSend == 'send' && order.status == 'shipped') order.sendtrackingstatus = true

      if (order) {
        order.productdetail = JSON.stringify(order.productdetail)
        api.editOrderSummary(order, function (error, response) {
          if (error) {
            console.error(error)
            vm.loadUpdateOrder = false
            return
          }
          if (response.responsecode === 200) {
            order.productdetail = JSON.parse(order.productdetail)
          }
          vm.loadUpdateOrder = false
        })
      }
    },

    async fetchData() {
      this.infiniteScroll()
    },
    toggle(index) {
      this.orders[index].toggle = !this.orders[index].toggle
    },
    async infiniteScroll($state) {
      try {
        const vm = this
        var { result } = await api.liveChatUserOrders({
          pageid: this.$store.state.livechat.pageid,
          userid: this.$store.state.livechat.currentUser.userid,
          limit: 5,
          offset: this.offset
        })
        if (result) {
          // console.log(result)
          setTimeout(() => {
            this.loading = false
            if (result.length >= 1) {
              result.forEach((item) => {
                item.toggle = false
                if (vm.selectedBot.type !== 'dtac-gaming') {
                  item.productdetail = JSON.parse(item.productdetail)
                }
                // console.log(item)
                this.orders.push(item)
              })
              // console.log(this.orders)
              this.offset += 5
              if ($state) $state.loaded()
            } else {
              if ($state) $state.complete()
            }
          }, 500)
        }
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    DateFormat(date) {
      return dayjs(date).locale(this.currentLang).format('dddd, MMMM D, YYYY h:mm A')
    },
    refreshData() {
      this.orders = []
      this.offset = 0
      this.loading = true
      this.fetchData()
    }
  }
}
</script>

<style scoped>
.theme--light.v-card {
  background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-order-summary.vue